module.exports = {
  productSettings: {
    excludeFromQuote: 'Exclude from quote',
    properties: 'Properties',
    options: 'Options',
    componentTypes: {
      chimney: {
        diameters: 'Diameters',
      },
    },
  },

  commentMode: 'Tap anywhere on the screen to add a new comment',
  comment: {
    insertPlaceholder: 'Insert comment',
  },

  footer: 'This is a presentation of the principles of the system, it is in no way a technical scheme and doesn\'t take into account any safeties',

  productList: {
    noProductAvailable: 'No products available',
  },

  productTypes: {
    solarKit: {
      piping10: 'Leidingwerk 10 meter',
      piping15: 'Leidingwerk 15 meter',
    },
  },

  chimneyTitle: 'Chimney {layout}',

  categories: {
    chimney: {
      this: 'this chimney',
    },
  },

  addProductModal: {
    title: 'Add Product',
    categories: {
      controllers: 'Controllers',
      hydraulics: 'Hydraulics',
      chimneys: 'Chimney',
      heatPumps: 'Heat Pumps',
      solarSystems: 'Solar Systems',
      kettle: 'Heat generators',
      boiler: 'Boilers',
    },
    categoryTitles: {
      controllers: 'Add controllers',
      hydraulics: 'Add hydraulics',
      chimneys: 'Add chimney',
      heatPumps: 'Add Heat Pump',
      solarsystem: 'Add Solar System',
      kettle: 'Add Heat Generator',
      boiler: 'Add Boiler',
    },
  },
  replaceProductModal: {
    title: 'Replace {product}',
  },

  removeProduct: {
    warning: {
      title: 'Remove {product}',
      text: 'Are you sure you want to remove {product} from this system?',
    },
  },

  nextLink: 'Next',
};



// WEBPACK FOOTER //
// ./js/lang/en/configurator.js